import React from "react";
import Preloader from "../Global/Preloader";
import Header from "../Global/Header";
import BredCrumb from "../Global/BredCrumb";
import Positive from "../MenReviews/Positive";
import Download from "../Menhomeone/Download";
import Call from "../MenAboutus/Call";
import Footer from "../Global/Footer";
import GoToTop from "../Global/GoToTop";
const Main =()=>{
    return(
        <>
              <Preloader/>
              <Header/>
              <BredCrumb Title="Client Reviews" subtitle=" Reviews" />
              <div className="page_wrapper">
              <Positive/>
              <Download/>
              <Call/>
              <Footer/>
              <GoToTop/>


              </div>

    
        </>
    )
}
export default Main;